import PropTypes from 'prop-types';
import React from 'react';
import { addMinutes } from "date-fns";
import { getTimelineOffset } from "../TimelineLogic";
import { intervalFromState } from "../../../Helpers/IntervalHelper";

const getNowTrackStyle = (error, sourceOffset, targetOffset, disabled) => {
    const basicStyle = {
        left: `${sourceOffset}%`,
        width: `calc(${targetOffset - sourceOffset}% + 1px)`,
    }

    if (disabled) {
        return basicStyle
    }

    const coloredTrackStyle = (error)
        ? {
            backgroundColor: 'rgba(214,0,11,0.5)',
            borderLeft: '1px solid rgba(214,0,11,0.5)',
            borderRight: '1px solid rgba(214,0,11,0.5)',
        }
        : {
            backgroundColor: 'var(--siteconfig-ui-btn-stdcolor-rgba)',
            borderLeft: 'var(--siteconfig-ui-btn-stdcolor-rgba)',
            borderRight: 'var(--siteconfig-ui-btn-stdcolor-rgba)',
        }

    return { ...basicStyle, ...coloredTrackStyle }
}

const NowTrack = ({ error, getTrackProps, disabled, timelineInterval }) => {

    timelineInterval = intervalFromState(timelineInterval);
    const sourceOffset = getTimelineOffset(timelineInterval, new Date());
    const targetOffset  = getTimelineOffset(timelineInterval, addMinutes(new Date(), 1));

    return (
        <div
            className={`react_time_range__track${disabled ? '__disabled' : ''} now-track ${error ? 'error' : ''}`}
            style={{
                left: `${sourceOffset}%`,
                width: `calc(${targetOffset - sourceOffset}% + 1px)`,
            }}
            {...getTrackProps()}
        >
            <div className='react_time_range__tick_label now-track-label'>
                NOW
            </div>
        </div>
    );
}

NowTrack.propTypes = {
    getTrackProps: PropTypes.func.isRequired,
    disabled: PropTypes.bool
}

NowTrack.defaultProps = {
    disabled: false,
}

export default NowTrack
